import { render, staticRenderFns } from "./reset-subject.vue?vue&type=template&id=9381b17e&scoped=true&"
import script from "./reset-subject.vue?vue&type=script&lang=js&"
export * from "./reset-subject.vue?vue&type=script&lang=js&"
import style0 from "./reset-subject.vue?vue&type=style&index=0&id=9381b17e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9381b17e",
  null
  
)

export default component.exports